import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { CustomerListComponent } from './customer-list/customer-list.component';
// import { CustomerProfileComponent } from './customer-profile/customer-profile.component';
// import { UpdateCustomerAddressComponent } from './update-customer-address/update-customer-address.component';
import { UpdateCustomerComponent } from './update-customer/update-customer.component';
import { CustomerInfoComponent } from './customer-info/customer-info.component';
import { CustomerProfileComponent } from './customer-info/customer-profile/customer-profile.component';
import { AddCustomerAddressComponent } from './customer-info/add-customer-address/add-customer-address.component';
import { CustomerCardComponent } from './customer-info/customer-card/customer-card.component';
import { CustomerOrderComponent } from './customer-info/customer-order/customer-order.component';
import { CustomerFeedbackComponent } from './customer-info/customer-feedback/customer-feedback.component';



 const routes: Routes = [
  { path: 'customers',      component: CustomerListComponent },
  // { path: 'add-customer',      component: CustomerProfileComponent },
  { path: 'customerinfo/:Id', component: CustomerInfoComponent,
  children: [
    {path: 'profile', component: CustomerProfileComponent},
    {path: 'address', component: AddCustomerAddressComponent},
    {path: 'card', component: CustomerCardComponent},
    {path: 'order', component: CustomerOrderComponent},
    {path: 'feedback', component: CustomerFeedbackComponent}

  ]
  },
  { path: 'update-customer/:Id', component: UpdateCustomerComponent
  },
  // { path: 'customer'}

];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
  })
  export class CustomerRoutingModule { }
